/* Hero-diavoorstelling. Progressieve verbetering: het spoor is een gewone
   scroll-snap-container, dus zonder dit bestand kun je nog steeds schuiven en
   is elke dia bereikbaar. Dit voegt alleen pijlen, streepjes en de teller toe.

   Twee dingen uit eerdere thema's:
   - de waarnemer wordt vastgehouden, anders ruimt de garbage collector hem op
     en vuurt hij precies één keer;
   - er wordt niet geanimeerd met transform maar met scrollLeft, zodat swipen
     blijft werken. */

(function () {
  'use strict';

  class Hero extends HTMLElement {
    connectedCallback() {
      this.spoor = this.querySelector('[data-hero-track]');
      this.dias = [...this.querySelectorAll('[data-hero-slide]')];
      this.streepjes = [...this.querySelectorAll('[data-hero-dot]')];
      this.teller = this.querySelector('[data-hero-count]');
      if (!this.spoor || this.dias.length < 2) return;

      this.huidig = 0;

      const vorige = this.querySelector('[data-hero-prev]');
      const volgende = this.querySelector('[data-hero-next]');
      if (vorige) vorige.addEventListener('click', () => this.ga(this.huidig - 1));
      if (volgende) volgende.addEventListener('click', () => this.ga(this.huidig + 1));
      this.streepjes.forEach((s, i) => s.addEventListener('click', () => this.ga(i)));

      // Bijhouden welke dia in beeld staat, ook als er met de vinger geschoven
      // wordt. Vastgehouden aan de instantie.
      this.waarnemer = new IntersectionObserver(
        (regels) => {
          regels.forEach((r) => {
            if (!r.isIntersecting) return;
            const i = this.dias.indexOf(r.target);
            if (i >= 0) this.markeer(i);
          });
        },
        { root: this.spoor, threshold: 0.6 }
      );
      this.dias.forEach((d) => this.waarnemer.observe(d));

      this.startAutoplay();
      this.addEventListener('pointerenter', () => this.stopAutoplay());
      this.addEventListener('pointerleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.waarnemer) this.waarnemer.disconnect();
    }

    ga(i) {
      const n = this.dias.length;
      const doel = ((i % n) + n) % n;
      this.spoor.scrollTo({ left: this.dias[doel].offsetLeft, behavior: 'smooth' });
      this.markeer(doel);
    }

    markeer(i) {
      this.huidig = i;
      this.streepjes.forEach((s, j) => s.classList.toggle('is-actief', j === i));
      if (this.teller) {
        const twee = (n) => String(n).padStart(2, '0');
        this.teller.textContent = twee(i + 1) + ' / ' + twee(this.dias.length);
      }
    }

    startAutoplay() {
      const sec = parseInt(this.dataset.autoplay || '0', 10);
      if (!sec) return;
      if (window.ncReducedMotion && window.ncReducedMotion()) return;
      this.stopAutoplay();
      this.timer = setInterval(() => this.ga(this.huidig + 1), sec * 1000);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }
  }

  // Defensief: de thema-editor laadt secties opnieuw in dezelfde pagina.
  if (!customElements.get('hws-hero')) customElements.define('hws-hero', Hero);
})();
